import React from "react";
import "./footer.css";
import Logo from "../../Portfolio Asset/Hephzibah Designs.png";

import SubFooter from "./SubFooter";

const Footer = () => {
  return (
    <div className="app__footer">
      <div className="app__footer-top">
        <div className="app__footer-logo">
          <img src={Logo} alt="Footer Logo" />
        </div>

        <div className="app__footer-right">
          <p className="footer__p-text">+234 703561 4626</p>
          <p className="footer__p-text">paul.ayeni0212@gmail.com</p>
        </div>
      </div>
      <div className="app__subline">
        <div className="app__subfooter-border"></div>
      </div>
      <SubFooter />
    </div>
  );
};

export default Footer;
